import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleSafety } from '@/mocks/articles';

export default function SafetyGuidePage() {
  return <ArticleLayout article={articleSafety} />;
}